import { observer } from 'mobx-react-lite'
import { type FirmDashboardJobTableViewModel } from '@/features/jobs/dashboard/FirmDashboardJobTableViewModel'
import { FirmDashboardJobCount } from '@/features/jobs/dashboard/components/FirmDashboardJobCount'

export interface FirmDashboardJobCountContainerProps {
  vm: FirmDashboardJobTableViewModel
}

export const FirmDashboardJobCountContainer = observer(
  function FirmDashboardJobCountContainer({
    vm,
  }: FirmDashboardJobCountContainerProps) {
    return <FirmDashboardJobCount totalJobs={vm.searcher.totalJobs} />
  },
)
